import { findClosestHueColorIndexFromList } from 'src/modules/designStudio/helpers/colorUtils';
import type {
  MaterialGroup,
  Product,
  Variation,
} from 'src/modules/designStudio/helpers/productSelection/types';
import { ProductTypeLabel } from 'src/modules/designStudio/helpers/productSelection/types';

export const findClosestColorMatchInProductLine = (
  product: Product,
  hex: string,
): Variation => {
  const allVariationColors = product.variations.map(
    v => v.color?.hex ?? '#ffffff',
  );
  const index = findClosestHueColorIndexFromList(hex, allVariationColors);
  return index ? product.variations[index] : product.variations[0];
};

export const getMaterialColor = (material: MaterialGroup): string => {
  const variation = material.variation!;
  const materialIsRoof =
    material.variation?.product.type === ProductTypeLabel.METAL_ROOF ||
    material.variation?.product.type === ProductTypeLabel.SHINGLE_ROOF ||
    material.variation?.product.type === ProductTypeLabel.TILE_ROOF;
  return materialIsRoof
    ? variation.name
    : findClosestColorMatchInProductLine(
        variation.product,
        material.appearance.color ?? '#ffffff',
      ).name;
};
